import { render, staticRenderFns } from "./MusicPlayer.vue?vue&type=template&id=16984c14&scoped=true&"
import script from "./MusicPlayer.vue?vue&type=script&lang=js&"
export * from "./MusicPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16984c14",
  null
  
)

export default component.exports